// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vjbh2Cny2UMCoWzAVm_r{flex-wrap:wrap;gap:4px;display:flex}.IoAExKzpZLApx8vVpiC7{flex-wrap:nowrap}.IoAExKzpZLApx8vVpiC7 .FF1Qw8YXXRwDOx3PG9Kk{margin-left:0}.FF1Qw8YXXRwDOx3PG9Kk{border:1px solid var(--border-neutral-default);background:var(--background-primary-Inverted-primary);color:var(--content-primary-primary);border-radius:6px;margin-left:4px;padding:3px 7px;font-size:13px;font-weight:400;line-height:16px;display:inline-block}.T1XO1UuYNBQb79Sp2gUt{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `Vjbh2Cny2UMCoWzAVm_r`,
	"triggerOneRow": `IoAExKzpZLApx8vVpiC7`,
	"remainderCount": `FF1Qw8YXXRwDOx3PG9Kk`,
	"item": `T1XO1UuYNBQb79Sp2gUt`
};
export default ___CSS_LOADER_EXPORT___;
